/* ================================================
   Pop-up Na Fali – Łukasz Mrowiec
   Plik: popup.js
   ================================================ */

;(function () {
	/* -----------------------------------------------
     KONFIGURACJA – jedyne miejsce do edycji
  ----------------------------------------------- */

	const API_URL = '/admin/api.php'

	const FALLBACK_TYTUL = 'Witaj na stronie Na Fali!'
	const FALLBACK_TRESC = 'Zapraszam do zapoznania się z ofertą zajęć pływania dla wszystkich poziomów zaawansowania.'

	const OPOZNIENIE_MS = 3000

	/* -----------------------------------------------
     LOGIKA – nie edytuj poniżej
  ----------------------------------------------- */

	if (sessionStorage.getItem('nafali-seen') === '1') {
		ukryjOverlay()
		return
	}

	document.getElementById('nafali-btn').addEventListener('click', function () {
		sessionStorage.setItem('nafali-seen', '1')
		ukryjOverlay()
		document.body.style.overflow = ''
	})

	// Fetch odpala się dopiero po OPOZNIENIE_MS – nie blokuje LCP
	setTimeout(function () {
		fetch(API_URL)
			.then(r => r.json())
			.then(data => {
				if (data.enabled == 0) return
				pokazTresc(data.tytul, data.tresc)
			})
			.catch(() => {
				pokazTresc(FALLBACK_TYTUL, FALLBACK_TRESC)
			})
	}, OPOZNIENIE_MS)

	/* -----------------------------------------------
     FUNKCJE POMOCNICZE
  ----------------------------------------------- */

	function pokazTresc(tytul, tresc) {
		const overlay = document.getElementById('nafali-overlay')
		const loader = document.getElementById('nafali-loader')
		const elTytul = document.getElementById('nafali-title')
		const elTresc = document.getElementById('nafali-tresc')

		if (loader) loader.style.display = 'none'

		if (elTytul) {
			elTytul.textContent = tytul
			elTytul.style.display = 'block'
		}

		if (elTresc) {
			elTresc.textContent = tresc
			elTresc.style.display = 'block'
		}

		if (overlay) {
			overlay.style.display = 'flex'
			document.body.style.overflow = 'hidden'
		}
	}

	function ukryjOverlay() {
		const overlay = document.getElementById('nafali-overlay')
		if (overlay) overlay.style.display = 'none'
	}
})()
